import funnel from './fr.json';

const fr = {
  ...funnel,
};

export { fr };
